<template>
  <div id="but">
    <div class="mybut">
      <div
        :class="$store.state.change_shebei ? 'but_3' : 'but_3_change'"
        @click="changebut"
      id="shebei_but"></div>
      <div
        :class="$store.state.give_water ? 'but_1' : 'but_1_change'"
        @click="givewater"
      ></div>
      <div
        :class="$store.state.give_xiaofang ? 'but_2' : 'but_2_change'"
        @click="xiaofang_choose"
      ></div>
      <!-- <div
        :class="$store.state.pressBut ? 'press_but' : 'press_but_change'"
        @click="pressbut"
      ></div> -->
    </div>
    <div class="dian_but" v-show="$store.state.but_show">
      <div class="xiaofangshuang" @click="xiaofangshow">
        <div
          :class="$store.state.xiaofangisshow ? 'xiaofang' : 'xiaofang_change'"
        ></div>
        <div
          :class="
            $store.state.xiaofangisshow ? 'xiaofang_1' : 'xiaofang_change_1'
          "
        ></div>
      </div>
      <div class="famen_but" @click="famenshow">
        <div :class="$store.state.famenisshow ? 'famen' : 'famen_change'"></div>
        <div
          :class="$store.state.famenisshow ? 'famen_1' : 'famen_change_1'"
        ></div>
      </div>
      <div class="shuibiao_but" @click="watchshow">
        <div
          :class="$store.state.watchisshow ? 'shuibiao' : 'shuibiao_change'"
        ></div>
        <div
          :class="$store.state.watchisshow ? 'shuibiao_1' : 'shuibiao_change_1'"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // change_shebei: true,  //控制设备管理得状态

      mytype_1: true,  //节流所用
      mytype_2: true,
      mytype_3: true,
    };
  },
  methods: {
    //but_show显示与隐藏
    changebut() {
      this.$store.commit("changebutshow");
      this.$store.commit('change_shebei_but');
      // this.$store.state.change_shebei
      // this.change_shebei = !this.change_shebei;
    },
    givewater() {
      // 在点击给水按钮的时候，控制其他一些属性
      this.$store.commit("environmentchange_1");
      document.getElementById("iframe").contentWindow.MMAPI.givewater(this.$store.state.give_water,this.$store.state.environmentchange);
      this.$store.commit("changegive_water_2");
      this.$store.commit("changepressbut_1");
      
      this.$store.commit("changewatchshow_3");
      this.$store.commit("changefamenshow_2");
      this.$store.commit("changexiaofangshow_2");
      this.$store.commit("tumingvaluechange"); //透明度数值还原
      
      if(!this.$store.state.give_water){
        this.$store.commit('change_shebei_true');
        this.$store.commit("changebutshowfalse");
        setTimeout(()=>{
          document.getElementById('shebei_but').className = "but_3 jinzhi"
        },100)
      }
      

      if(this.$store.state.give_water&this.$store.state.give_xiaofang){
        // 还原classname
        setTimeout(()=>{
          document.getElementById('shebei_but').className = "but_3"
        },100)
      }
      
    },
    xiaofang_choose() {
      // 消防按钮
      this.$store.commit("environmentchange_1");
      document.getElementById("iframe").contentWindow.MMAPI.givexiaofang(this.$store.state.give_xiaofang,this.$store.state.environmentchange);
      this.$store.commit("changegive_xiaofang_2");
      this.$store.commit("changepressbut_1");      
      this.$store.commit("changewatchshow_3");
      this.$store.commit("changefamenshow_2");
      this.$store.commit("changexiaofangshow_2");
      this.$store.commit("tumingvaluechange"); //透明度数值还原

      if(!this.$store.state.give_xiaofang){
        this.$store.commit('change_shebei_true');
        this.$store.commit("changebutshowfalse");
        setTimeout(()=>{
          document.getElementById('shebei_but').className = "but_3 jinzhi"
        },100)
      }
      

      if(this.$store.state.give_water&this.$store.state.give_xiaofang){
        // 还原classname
        setTimeout(()=>{
          document.getElementById('shebei_but').className = "but_3"
        },100)    
      }
    },
    watchshow() {
      // 水表按钮
      // 使用节流方式，防止多次点击
      if(this.mytype_3){
        this.mytype_3=false;
        document.getElementById("iframe").contentWindow.MMAPI.waterwatch(this.$store.state.watchisshow,this.$store.getters.f_PointData);
        this.$store.commit("changewatchshow_2");
        this.$store.commit("changegive_water_1");
        this.$store.commit("changegive_xiaofang_1");
        this.$store.commit("changepressbut_1");
        this.$store.commit("environmentchange_1");
        setTimeout(()=>{
          this.mytype_3=true;
        },500)
      }
      
    },
    famenshow() {
      if(this.mytype_2){
        this.mytype_2=false;
        document.getElementById("iframe").contentWindow.MMAPI.famen(this.$store.state.famenisshow);
        this.$store.commit("changefamenshow_1");
        this.$store.commit("changegive_water_1");
        this.$store.commit("changegive_xiaofang_1");
        this.$store.commit("changepressbut_1");
        this.$store.commit("environmentchange_1");
        setTimeout(()=>{
          this.mytype_2=true
        },500)
      }
      
    },
    xiaofangshow() {
      if(this.mytype_1){
        this.mytype_1 = false
        document.getElementById("iframe").contentWindow.MMAPI.xiaofang(this.$store.state.xiaofangisshow);
        this.$store.commit("changexiaofangshow_1");
        this.$store.commit("changegive_water_1");
        this.$store.commit("changegive_xiaofang_1");
        this.$store.commit("changepressbut_1");
        this.$store.commit("environmentchange_1");
        setTimeout(()=>{
          this.mytype_1=true;
        },500)
      }
           
    }
  },
};
</script>

<style scoped>
#but {
  width: 20vw;
  height: 23vh;
}
.mybut {
  position: absolute;
  top: 0;
  right: 0;
  width: 3.44vw;
  height: 23vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.but_1 {
  background: url("@/assets/icon/geishui_f.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6vh;
  cursor: pointer;
}
.but_1_change {
  background: url("@/assets/icon/geishui_t.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6vh;
  cursor: pointer;
}
.but_2 {
  background: url("@/assets/icon/xiaofang_f.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6.8vh;
  cursor: pointer;
}
.but_2_change {
  background: url("@/assets/icon/xiaofang_t.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6.8vh;
  cursor: pointer;
}
.but_3 {
  background: url("@/assets/icon/shebei_f.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6.5vh;
  cursor: pointer;
}
.but_3_change {
  background: url("@/assets/icon/shebei_t.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6.5vh;
  cursor: pointer;
}
.press_but {
  background: url("@/assets/press_false.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6.5vh;
  cursor: pointer;
}
.press_but_change {
  background: url("@/assets/press_true.png") no-repeat center center;
  background-size: 100% 100%;
  width: 3.54vw;
  height: 6.5vh;
  cursor: pointer;
}
.dian_but {
  width: 13.28vw;
  height: 7.31vh;
  /* position: absolute;
    right: 20%;
    top: 15%; */
  display: flex;
  justify-content: space-around;
}
.xiaofangshuang,
.famen_but,
.shuibiao_but {
  width: 70px;
  height: 70px;
}
.xiaofang {
  background: url("@/assets/icon/xiaofangshuang_f_1.png") no-repeat center
    center;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: relative;
  top: 50%;
  left: 50%;
  margin-top: -15px;
  margin-left: -15px;
}
.xiaofang_change {
  background: url("@/assets/icon/xiaofangshuang_t_1.png") no-repeat center
    center;
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: relative;
  top: 50%;
  left: 50%;
  margin-top: -15px;
  margin-left: -15px;
}
.xiaofang_1 {
  background: url("@/assets/icon/icon_anim_f.png") no-repeat center center;
  background-size: 100% 100%;
  width: 70px;
  height: 70px;
  cursor: pointer;
  animation: icon_anim 2.5s linear infinite;
  position: relative;
  top: -20%;
  left: 0;
}
.xiaofang_change_1 {
  background: url("@/assets/icon/icon_anim_t.png") no-repeat center center;
  background-size: 100% 100%;
  width: 70px;
  height: 70px;
  cursor: pointer;
  animation: icon_anim 2.5s linear infinite;
  position: relative;
  top: -20%;
  left: 0;
}
@keyframes icon_anim {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.famen {
  background: url("@/assets/icon/famen_f_1.png") no-repeat center center;
  background-size: 100% 100%;
  width: 20px;
  height: 30px;
  cursor: pointer;
  position: relative;
  top: 50%;
  left: 50%;
  margin-top: -15px;
  margin-left: -10px;
}
.famen_change {
  background: url("@/assets/icon/famen_t_1.png") no-repeat center center;
  background-size: 100% 100%;
  width: 20px;
  height: 30px;
  cursor: pointer;
  position: relative;
  top: 50%;
  left: 50%;
  margin-top: -15px;
  margin-left: -10px;
}
.famen_1 {
  background: url("@/assets/icon/icon_anim_f.png") no-repeat center center;
  background-size: 100% 100%;
  width: 70px;
  height: 70px;
  cursor: pointer;
  animation: icon_anim 2.5s linear infinite;
  position: relative;
  top: -20%;
  left: 0;
}
.famen_change_1 {
  background: url("@/assets/icon/icon_anim_t.png") no-repeat center center;
  background-size: 100% 100%;
  width: 70px;
  height: 70px;
  cursor: pointer;
  animation: icon_anim 2.5s linear infinite;
  position: relative;
  top: -20%;
  left: 0;
}
.shuibiao {
  background: url("@/assets/icon/shuibiao_f_2.png") no-repeat center center;
  background-size: 100% 100%;
  width: 20px;
  height: 30px;
  cursor: pointer;
  position: relative;
  top: 50%;
  left: 50%;
  margin-top: -15px;
  margin-left: -10px;
}
.shuibiao_change {
  background: url("@/assets/icon/shuibiao_t_2.png") no-repeat center center;
  background-size: 100% 100%;
  width: 20px;
  height: 30px;
  cursor: pointer;
  position: relative;
  top: 50%;
  left: 50%;
  margin-top: -15px;
  margin-left: -10px;
}
.shuibiao_1 {
  background: url("@/assets/icon/icon_anim_f.png") no-repeat center center;
  background-size: 100% 100%;
  width: 70px;
  height: 70px;
  cursor: pointer;
  animation: icon_anim 2.5s linear infinite;
  position: relative;
  top: -20%;
  left: 0;
}
.shuibiao_change_1 {
  background: url("@/assets/icon/icon_anim_t.png") no-repeat center center;
  background-size: 100% 100%;
  width: 70px;
  height: 70px;
  cursor: pointer;
  animation: icon_anim 2.5s linear infinite;
  position: relative;
  top: -20%;
  left: 0;
}
.jinzhi{
  cursor: not-allowed;
  pointer-events: none;
  
}
</style>